/**
 * Input:  object tab (voce AppTabs: to, text + gate opzionali module/model/setting),
 *         object getters (store.getters)
 * Fa:     valuta i gate presenti sulla tab — devono valere TUTTI (es. Widget
 *         richiede sia la feature di tenant sia il permesso di ruolo)
 * Output: boolean
 *
 * Modulo volutamente SENZA import: e' consumato da AppTabs.vue, che router/index.js
 * carica per primo. Importare qui lo store lo anticiperebbe nel grafo dei moduli,
 * invertendo il ciclo router → AppTabs → store → router (l'export AppTabs arriva
 * undefined e la rotta padre non monta nulla).
 */
export function isTabAllowed(tab, getters) {
	if (typeof tab.module !== 'undefined' && !getters.checkModulePermissions(tab.module)) {
		return false
	}
	if (typeof tab.model !== 'undefined' && !getters.checkModelPermissions(tab.model)) {
		return false
	}
	if (typeof tab.setting !== 'undefined' && !getters.checkSettings(tab.setting)) {
		return false
	}
	return true
}
